<div
	class="category-item"
	*ngFor="let fullStar of categoryStars"
	[class.half]="!fullStar"
	[class.full]="fullStar"
></div>

<!--svg icon *ngFor="let fullStar of categoryStars" [type]="fullStar ? 'star' : 'star-half'"></svg-->
